import { useTracking } from '@vp/react-tracking';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Button, FlexBox } from '@vp/swan';
import { CollaborationFile } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { TRACKING_PAGE_MY_ACCOUNT, useCollaborationContext } from '../../context';
import { DesignRevisionMeta, PinComment, PinCommentList, TextSection } from '../../ui';
import { ReferenceImageSection } from './components/ReferenceImageSection';

export interface DesignRevisionFeedbackPanelProps {
    version: string;
    remainingRevisions: number;
    collaborationId: string;
    pinnedComments: PinComment[];
    generalComment: string;
    onClick?: () => void;
    files: CollaborationFile[];
}

export function DesignRevisionFeedbackPanel(props: DesignRevisionFeedbackPanelProps) {
    const { tracking } = useTracking();
    const { trackingProperties } = useCollaborationContext();

    useEffect(() => {
        tracking.page('Design Services:Collaboration:Revision Feedback', {
            ...trackingProperties,
            pageName: `Design Services:Collaboration:Revision Feedback:${trackingProperties.collaborationStatus}`,
            pageSection: TRACKING_PAGE_MY_ACCOUNT,
            pageStage: TRACKING_PAGE_MY_ACCOUNT,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Helmet>
                <title>{__('Vistaprint | Design Services Revision Feedback')}</title>
            </Helmet>
            <FlexBox flexDirection="column" gap={'between-sections'} paddingX="7" paddingY="10">
                <DesignRevisionMeta
                    revisionVersion={props.version}
                    remainingRevisions={props.remainingRevisions}
                />
                {props.generalComment.length > 0 && (
                    <TextSection heading={__('General comment')} text={props.generalComment} />
                )}
                {props.pinnedComments.length > 0 && (
                    <PinCommentList comments={props.pinnedComments} />
                )}
                {props.files.length > 0 && <ReferenceImageSection files={props.files} />}
                <TextSection heading={__('ID')} text={props.collaborationId} />
                <Box>
                    <Button onClick={props.onClick} standardMode width="standard">
                        {__('Back')}
                    </Button>
                </Box>
            </FlexBox>
        </>
    );
}
